import { useTranslation } from "react-i18next";
import { MessageThread } from "../../features/messages/models/MessageThread";

interface ThreadTitleProps {
  thread: MessageThread;
}

/**
 * The thread's name; on a Direct thread whose other side is connected, a green dot before it and
 * "Online" under it (PD-0040). Nothing at all otherwise: no "offline", no "last seen".
 */
const ThreadTitle = ({ thread }: ThreadTitleProps) => {
  const { t } = useTranslation();
  const online = thread.counterpartOnline === true;
  return (
    <div className="min-w-0">
      <h2 className="flex items-center gap-2 text-lg font-semibold text-grey-20 dark:text-white">
        {online && (
          <span
            aria-hidden="true"
            data-testid="online-dot"
            className="h-2 w-2 shrink-0 rounded-full bg-green-700 dark:bg-green-400"
          />
        )}
        {thread.title}
      </h2>
      {online && <p className="text-sm text-green-700 dark:text-green-400">{t("messages.online")}</p>}
    </div>
  );
};

export default ThreadTitle;
